/** @jsxImportSource @emotion/react */
import { Button, List, ListItem, useTheme } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import React, { ReactElement } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

import { useStyles } from './SideBarNav.styles';

type SidebarNavProps = {
  className?: string;
  pages: Array<{
    icon: ReactElement;
    title: string;
    path?: string;
    onClick?: () => void;
  }>;
  onLinkClick?: () => void;
};

const defaultProps = {
  className: '',
  pages: [],
};

export function SidebarNav({
  pages,
  className,
  onLinkClick,
}: SidebarNavProps = defaultProps): React.ReactElement {
  const theme = useTheme();
  const styles = useStyles(theme);

  const getDefaultIcons = () => [
    <FolderOpenIcon key={0} />,
    <FolderIcon key={1} />,
  ];

  const iconRender = (icon) =>
    Array.isArray(icon) ? (
      <div className="icons">
        <div className="icon-active icon">{icon[0] || null}</div>
        <div className="icon-inactive icon">{icon[1] || null}</div>
      </div>
    ) : (
      <div className="icon">{icon}</div>
    );

  //todo Button activeClassName="active"
  return (
    <List className={className} css={styles}>
      {pages.map((page) => (
        <ListItem className="item" disableGutters key={page.title}>
          {page.onClick ? (
            <Button className="button" onClick={page.onClick}>
              {iconRender(page.icon || getDefaultIcons())}
              <span className="title">{page.title}</span>
            </Button>
          ) : (
            <Button
              className="button"
              component={RouterLink}
              to={page.path}
              onClick={onLinkClick}
            >
              {iconRender(page.icon || getDefaultIcons())}
              <span className="title">{page.title}</span>
            </Button>
          )}
        </ListItem>
      ))}
    </List>
  );
}
